import React, { useState, useRef, useEffect } from 'react';
import './frameNewback.css';
import chatSoundIconWhite from '../../../static/img/chatSoundSpeaker.png'
import chatSpeakerMuteIcon from '../../../static/img/chatMuteSpeaker.png'
import chatBotAvatarGala from '../../../static/img/chatBotAvatarGala.png'
import chatBotAvatarDiana from '../../../static/img/chatBotAvatarDiana.png'
import { useParams } from 'react-router-dom';
import natashaGifCircle from '../../../static/img/circleGif/natashaGifCircle.gif'
import galaGifCircle from '../../../static/img/circleGif/galaGifCircle.gif'
import dianaGifCircle from '../../../static/img/circleGif/dianaGifCircle.gif'
import aubrey from '../../../static/img/circleGif/aubrey.jpg'
import bharathi from '../../../static/img/circleGif/bharathi.jpg'
import geuilia from '../../../static/img/circleGif/geuilia.jpg'
import natashaBg from '../../../static/img/natasha.png'
import geuiliaBg from '../../../static/img/geuilia3.png'
import galabg from '../../../static/img/galabg.png'
import dianabg from '../../../static/img/dianabg.png'
import aubreybg from '../../../static/img/aubreybg.png'
import greenSendIcon from '../../../static/img/greenSendIcon3.png'
import { languages } from './languages'
import axios from "axios"
import { Button, TextField, Box, Paper, Stack } from "@mui/material";
import TextRenderer from './TextRender';
const SreeChatID = () => {
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search.slice(1));
    let obj = {};
    for (let pair of params.entries()) {
        obj[pair[0]] = pair[1];
    }
    const preview = obj["preview"];
    const domain = obj["domain"];
    console.log(preview)
    const [selectedlanguage, setselectedlanguage] = useState("en");
    const [showChatBot, setShowChatBot] = useState(preview ? true : false);
    const [isvideoPlay, setisvideoPlay] = useState(false);
    const [isstaticVideo, setisstaticVideo] = useState(true);
    const urlParams = useParams()
    const [isSoundOn, setIsSoundOn] = useState(true);
    const { companyName, chatId, avatarName } = urlParams;
    const [hideChatInput, sethideChatInput] = useState(true)
    const [messages, setMessages] = useState([]);
    const [chatHistory, setChatHistory] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const [loading, setLoading] = useState(false);
    const [isRecordingTemp, setIsRecordingTemp] = useState(false);
    const messagesEndRef = useRef(null);
    const mediaRecorderRefTemp = useRef(null);
    const recordedChunksRefTemp = useRef([]);
    const mediaStreamRefTemp = useRef(null);
    const [recentBotIndex, setRecentBotIndex] = useState(null);
    const [recordMessage, setRecordMessage] = useState(false);
    const videoRef = useRef(null);
    const audioConstraintsTemp = {
        audio: {
            sampleRate: 16000,
            channelCount: 1,
            echoCancellation: false,
            noiseSuppression: false,
            autoGainControl: false,
        },
    };
    const isIOS = () => /iPhone|iPad|iPod/i.test(navigator.userAgent);
    const isSafari = () => {
        const ua = navigator.userAgent.toLowerCase();
        return ua.includes('safari') && !ua.includes('chrome');
    };
    useEffect(() => {
        if(!preview){
            callApiOnPageLoad("hi", 'onloadtime')
        }
        handleVideoPathmute()
    }, [])
    useEffect(() => {
        const latestBotIndex = messages
            .map((item, index) => (item.type === 'bot' ? index : null))
            .filter(index => index !== null)
            .pop();
        if (latestBotIndex !== null) {
            setRecentBotIndex(latestBotIndex);
        }
    }, [messages]);
    useEffect(() => {
        const timer = setTimeout(() => {
            setRecordMessage(false);
        }, 3000);
        return () => clearTimeout(timer);
    }, [recordMessage]);
    const audioRef = useRef(null);
    const base64ToBlob = (base64Data, contentType = '', sliceSize = 512) => {
        const byteCharacters = atob(base64Data);
        const byteArrays = [];
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        return new Blob(byteArrays, { type: contentType });
    };

    const sendAudioToApi = async () => {
        if (!isRecordingTemp) {
            try {
                mediaStreamRefTemp.current = await navigator.mediaDevices.getUserMedia(audioConstraintsTemp);
                const mimeType = isIOS() || isSafari() ? 'audio/mp4' : 'audio/webm';
                if (!MediaRecorder.isTypeSupported(mimeType)) {
                    console.warn(`${mimeType} is not supported on this browser. Falling back to a supported type.`);
                    return;
                }
                mediaRecorderRefTemp.current = new MediaRecorder(mediaStreamRefTemp.current, { mimeType });
                mediaRecorderRefTemp.current.ondataavailable = (event) => {
                    if (event.data.size > 0) {
                        recordedChunksRefTemp.current.push(event.data);
                    }
                };
                mediaRecorderRefTemp.current.onstop = async () => {
                    const blobTemp = new Blob(recordedChunksRefTemp.current, { type: mimeType });
                    recordedChunksRefTemp.current = [];
                    const readerTemp = new FileReader();
                    readerTemp.readAsDataURL(blobTemp);

                    readerTemp.onloadend = async () => {
                        setRecordMessage(true)
                        const base64AudioTemp = readerTemp.result.split(',')[1];
                        const formDataTemp = new FormData();
                        formDataTemp.append('audio_file', base64AudioTemp);
                        formDataTemp.append('file_extension', mimeType === 'audio/mp4' ? 'mp4' : 'webm');
                        try {
                            const responseTemp = await fetch(`https://speech.pranathiss.com/api/vad-base64-speech-to-text-avatar/`, {
                                method: 'POST',
                                body: formDataTemp,
                            });
                            const resultTemp = await responseTemp.json();
                            setRecordMessage(false)
                            callApiOnPageLoad(resultTemp.response, "", resultTemp.audiolang)
                        } catch (error) {
                            console.error(`Error: ${error.message}`);
                        }
                    };
                };
                mediaRecorderRefTemp.current.start();
                setIsRecordingTemp(true);
            } catch (error) {
                if (error.name === 'NotAllowedError') {
                    console.error('Microphone access was denied. Please enable it in your settings.');
                } else if (error.name === 'NotFoundError') {
                    console.error('No microphone found. Please connect a microphone.');
                } else {
                    console.error(`An unexpected error occurred: ${error.message}`);
                }
            }
        } else {
            mediaRecorderRefTemp.current.stop();
            mediaStreamRefTemp.current.getTracks().forEach((track) => track.stop());
            setIsRecordingTemp(false);
        }
    };
    const toggleSound = () => {
        let PreisSoundOn = isSoundOn
        if (videoRef.current) {
            videoRef.current.muted = PreisSoundOn;

        }
        if (audioRef.current) {
            audioRef.current.muted = PreisSoundOn;

        }
        setIsSoundOn(!PreisSoundOn)
    };
    const apiBaseUrl = 'https://app.avatarchatbots.ai/qxbox/apiV1/chat-response-v1/'
    const [form_detailList, setform_detailList] = useState([])
    const [formCount, setformCount] = useState(0)
    const [audio_data, setaudio_data] = useState(false)
    const [typingLoading, settypingLoading] = useState(false)
    const [storedResponses, setStoredResponses] = useState([]); // Stores chatbot responses
    const [formvideo, setformvideo] = useState()
    const [formsuccess, setformsuccess] = useState();
    const languages = [
        {
            "language": "Afrikaans",
            "code": "af"
        },
        {
            "language": "Albanian",
            "code": "sq"
        },
        {
            "language": "Amharic",
            "code": "am"
        },
        {
            "language": "Arabic",
            "code": "ar"
        },
        {
            "language": "Armenian",
            "code": "hy"
        },
        {
            "language": "Azerbaijani",
            "code": "az"
        },
        {
            "language": "Basque",
            "code": "eu"
        },
        {
            "language": "Bengali",
            "code": "bn"
        },
        {
            "language": "Bosnian",
            "code": "bs"
        },
        {
            "language": "Bulgarian",
            "code": "bg"
        },
        {
            "language": "Catalan",
            "code": "ca"
        },
        {
            "language": "Chinese (Simplified)",
            "code": "zh-CN"
        },
        {
            "language": "Croatian",
            "code": "hr"
        },
        {
            "language": "Czech",
            "code": "cs"
        },
        {
            "language": "Danish",
            "code": "da"
        },
        {
            "language": "Dutch",
            "code": "nl"
        },
        {
            "language": "English",
            "code": "en"
        },
        {
            "language": "Estonian",
            "code": "et"
        },
        {
            "language": "Finnish",
            "code": "fi"
        },
        {
            "language": "French",
            "code": "fr"
        },
        {
            "language": "Galician",
            "code": "gl"
        },
        {
            "language": "Georgian",
            "code": "ka"
        },
        {
            "language": "German",
            "code": "de"
        },
        {
            "language": "Greek",
            "code": "el"
        },
        {
            "language": "Hebrew",
            "code": "iw"
        },
        {
            "language": "Hindi",
            "code": "hi"
        },
        {
            "language": "Hungarian",
            "code": "hu"
        },
        {
            "language": "Icelandic",
            "code": "is"
        },
        {
            "language": "Indonesian",
            "code": "id"
        },
        {
            "language": "Irish",
            "code": "ga"
        },
        {
            "language": "Italian",
            "code": "it"
        },
        {
            "language": "Japanese",
            "code": "ja"
        },
        {
            "language": "Javanese",
            "code": "jw"
        },
        {
            "language": "Kannada",
            "code": "kn"
        },
        {
            "language": "Kazakh",
            "code": "kk"
        },
        {
            "language": "Khmer",
            "code": "km"
        },
        {
            "language": "Korean",
            "code": "ko"
        },
        {
            "language": "Lao",
            "code": "lo"
        },
        {
            "language": "Latvian",
            "code": "lv"
        },
        {
            "language": "Lithuanian",
            "code": "lt"
        },
        {
            "language": "Macedonian",
            "code": "mk"
        },
        {
            "language": "Malay",
            "code": "ms"
        },
        {
            "language": "Malayalam",
            "code": "ml"
        },
        {
            "language": "Maltese",
            "code": "mt"
        },
        {
            "language": "Mongolian",
            "code": "mn"
        },
        {
            "language": "Nepali",
            "code": "ne"
        },
        {
            "language": "Norwegian",
            "code": "no"
        },
        {
            "language": "Pashto",
            "code": "ps"
        },
        {
            "language": "Persian",
            "code": "fa"
        },
        {
            "language": "Polish",
            "code": "pl"
        },
        {
            "language": "Portuguese",
            "code": "pt"
        },
        {
            "language": "Romanian",
            "code": "ro"
        },
        {
            "language": "Russian",
            "code": "ru"
        },
        {
            "language": "Serbian",
            "code": "sr"
        },
        {
            "language": "Sinhala",
            "code": "si"
        },
        {
            "language": "Slovak",
            "code": "sk"
        },
        {
            "language": "Slovenian",
            "code": "sl"
        },
        {
            "language": "Somali",
            "code": "so"
        },
        {
            "language": "Spanish",
            "code": "es"
        },
        {
            "language": "Sundanese",
            "code": "su"
        },
        {
            "language": "Swahili",
            "code": "sw"
        },
        {
            "language": "Swedish",
            "code": "sv"
        },
        {
            "language": "Tamil",
            "code": "ta"
        },
        {
            "language": "Telugu",
            "code": "te"
        },
        {
            "language": "Thai",
            "code": "th"
        },
        {
            "language": "Turkish",
            "code": "tr"
        },
        {
            "language": "Ukrainian",
            "code": "uk"
        },
        {
            "language": "Urdu",
            "code": "ur"
        },
        {
            "language": "Uzbek",
            "code": "uz"
        },
        {
            "language": "Vietnamese",
            "code": "vi"
        },
        {
            "language": "Welsh",
            "code": "cy"
        },
        {
            "language": "Zulu",
            "code": "zu"
        }
    ]
    const callApiOnPageLoad = async (data, check, language=selectedlanguage) => {
        setonloadTime(true)
        setInputValue("")
        setaudio_data(false)
        settypingLoading(true)
        let object = {
            isuser: true,
            message: data,
            text: data,
            custom_payloads: [],
            api_details: false,
            api_call: {},
            form_status: false,
            form_details: []
        }

        if (check != "onloadtime") {
            let charts = messages
            charts.push(object)
            setMessages([...charts])
        }

        let charthistory21 = chatHistory
        charthistory21.push({ human: data })
        setChatHistory([...charthistory21])
        let req = {
            chatbot_id: chatId,
            user_id: companyName,
            chat_history: charthistory21,
            avatar_name: avatarName,
            language: language
        }
        setTimeout(() => {
            if (messagesEndRef.current) {
                messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
            }
        }, 300);
        try {
            const response = await fetch(`${apiBaseUrl}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(req),
            });

            if (response.ok) {

                const data = await response.json();
                setaudio_data(true)
                if (data.form_status) {
                    setformCount(0)
                    setform_detailList([...data.form_details])
                    console.log([...data.form_details], 'from response');
                    sethideChatInput(false)
                    setformsuccess(data.responses[0])
                    setformvideo(data.video_path)
                }

                let object = {
                    isuser: false,
                    message: data.form_status ? data.form_message : data.responses[0], // Show form_message if it exists
                    custom_payloads: data.custom_payloads,
                    api_details: data.api_details,
                    api_call: data.api_call,
                    form_status: data.form_status || false,
                    form_details: data.form_status ? data.form_details[0] : []
                };


                let charts = messages
                charts.push(object)
                setMessages([...charts])
                let object2 = {
                    ai: data.responses[0]
                }

                let charthistory2s = chatHistory

                charthistory2s.push(object2)

                setChatHistory([...charthistory2s])
                setInputValue("")
                if (data.form_status) {
                    setisstaticVideo(true)
                    setisvideoPlay(true)
                } else {
                    setisstaticVideo(false)
                    setisvideoPlay(true)
                }
                setTimeout(() => {
                    if (messagesEndRef.current) {
                        messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
                    }
                }, 300);
                if (data.audio_data) {
                    // Stop any existing audio before playing a new one
                    if (audioRef.current) {
                        audioRef.current.pause();
                        audioRef.current.currentTime = 0;
                        audioRef.current.src = "";
                    }

                    const audioBlob = base64ToBlob(data.audio_data, "audio/mp3");
                    const audioUrl = URL.createObjectURL(audioBlob);
                    const audioElement = new Audio(audioUrl);
                    audioRef.current = audioElement;
                    audioElement.muted = !isSoundOn;

                    if (videoRef.current) {
                        videoRef.current.src = data.video_path;
                        videoRef.current.muted = true;
                        videoRef.current.loop = false
                        const videoElement = videoRef.current;
                        videoElement.onloadeddata = async () => {
                            try {
                                // Ensure both start from the exact same position
                                audioElement.currentTime = 0;
                                videoElement.currentTime = 0;

                                await Promise.all([videoElement.play(), audioElement.play()]);
                            } catch (error) {
                                console.error("Autoplay failed:", error);
                            }
                        };

                        // Keep them in sync while playing
                        videoElement.onplay = () => {
                            if (data.audio_data) {
                                audioElement.currentTime = videoElement.currentTime;
                                audioElement.play();
                            }
                        };

                        videoElement.onpause = () => audioElement.pause();

                        videoElement.onseeked = () => {
                            audioElement.currentTime = videoElement.currentTime;
                        };
                        videoRef.current.onended = () => {
                            audioRef.current.src = ""
                            videoRef.current.src = `https://d1duq3wrgv494c.cloudfront.net/static/${avatarName}/${avatarName}_static.mp4`
                            videoRef.current.muted = true;
                            videoRef.current.loop = true;
                            videoRef.current.play();

                        };
                    }
                } else if (data.video_path) {
                    // Stop any previous audio when switching to a new video
                    if (audioRef.current) {
                        audioRef.current.pause();
                        audioRef.current.currentTime = 0;
                        audioRef.current.src = "";
                    }

                    if (videoRef.current && !data.form_status) {
                        videoRef.current.src = data.video_path;
                        videoRef.current.muted = !isSoundOn;
                        videoRef.current.loop = false
                        videoRef.current.play();

                        videoRef.current.onended = () => {
                            videoRef.current.src = `https://d1duq3wrgv494c.cloudfront.net/static/${avatarName}/${avatarName}_static.mp4`
                            videoRef.current.muted = true;
                            videoRef.current.loop = true;
                            videoRef.current.play();
                        };
                    }
                } else {
                    settypingLoading(false)
                }

                settypingLoading(false)


            } else {
                settypingLoading(false)
                const data = await response.json();
                let object = {
                    isuser: false,
                    message: data.message, // Show form_message if it exists

                };
                let charts = messages
                charts.push(object)
                setMessages([...charts])
                console.error('API error:', response.statusText);
            }
        } catch (error) {

            let object = {
                isuser: false,
                message: error.response.data.message, // Show form_message if it exists

            };
            let charts = messages
            charts.push(object)
            setMessages([...charts])
            console.error('Fetch error:', error);
        }
    };
    const handleFormSubmit = (e) => {
        e.preventDefault();
        if (inputValue) {
            callApiOnPageLoad(inputValue);
        }

    }
    const [onloadTime, setonloadTime] = useState(false)

    const [inputvaluesName, setinputvaluesName] = useState()
    const [validation, setvalidation] = useState("");
    const [data, setData] = useState({});
    const [inputValues, setInputValues] = useState({});
    const inputChangeTosubmit = (value, id, type, index, label) => {
        setData(prevData => ({ ...prevData, [label]: value }));

        setMessages(prevMessages => {
            let updatedMessages = [...prevMessages];
            updatedMessages[index] = { ...updatedMessages[index], validation: "" };
            return updatedMessages;
        });

        let isValid = true;
        const trimmedValue = value.trim();

        if (type === "Emailfield" && trimmedValue) {
            if (!/^\S+@\S+\.\S+$/.test(trimmedValue)) {
                setMessages(prevMessages => {
                    let updatedMessages = [...prevMessages];
                    updatedMessages[index] = { ...updatedMessages[index], validation: "Please enter a valid email" };
                    return updatedMessages;
                });
                isValid = false;
            }
        }
        if (type === "Integerfield" && trimmedValue) {
            if (!/^\d{9,12}$/.test(trimmedValue)) {
                setMessages(prevMessages => {
                    let updatedMessages = [...prevMessages];
                    updatedMessages[index] = { ...updatedMessages[index], validation: "Please enter a valid phone number (9 to 12 digits)." };
                    return updatedMessages;
                });
                isValid = false;
            }
        }

        setInputValues(prev => ({ ...prev, [label]: value }));
    };
    const handleInputFormSubmit = (e, api_details) => {
        e.preventDefault();

        // Validate Inputs Before Sending
        let isValid = true;
        form_detailList.forEach((field, index) => {
            let inputValue = data[field.label] || "";
            if (field.form_details === "Emailfield" && !/^\S+@\S+\.\S+$/.test(inputValue)) {
                setMessages(prevMessages => {
                    let updatedMessages = [...prevMessages];
                    updatedMessages[index] = { validation: "Please enter a valid email" };
                    return updatedMessages;
                });
                isValid = false;
            }
            if (field.form_details === "Integerfield" && !/^\d{9,12}$/.test(inputValue)) {
                setMessages(prevMessages => {
                    let updatedMessages = [...prevMessages];
                    updatedMessages[index] = { validation: "Please enter a valid phone number (9 to 12 digits)." };
                    return updatedMessages;
                });
                isValid = false;
            }
        });

        if (!isValid) return;

        console.log("Final Payload:", data);

        if (api_details.url) {
            // Proceed with API call only if URL is available
            if (api_details.method === "POST") {
                axios.post(api_details.url, data)
                    .then(() => {
                        handleFormSuccess();
                    })
                    .catch((e) => console.error("Error:", e));
            } else {
                axios.get(api_details.url, { params: data })
                    .then((rep) => console.log("Response:", rep))
                    .catch((e) => console.error("Error:", e));
            }
        } else {
            // If no API URL, just show the success message
            handleFormSuccess();
        }

        // Smooth scroll to bottom
        setTimeout(() => {
            if (messagesEndRef.current) {
                messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
            }
        }, 300);
    };
    const handleVideoPath = () => {
        videoRef.current.src = `https://d1duq3wrgv494c.cloudfront.net/static/${avatarName}/${avatarName}_static.mp4`
        videoRef.current.muted = !isSoundOn;
        videoRef.current.play();
    }
    const handleVideoPathmute = () => {
        videoRef.current.src = `https://d1duq3wrgv494c.cloudfront.net/static/${avatarName}/${avatarName}_static.mp4`
        videoRef.current.muted = true;
        videoRef.current.loop = true;
        videoRef.current.play();
    }
    // Function to handle form success behavior
    const handleFormSuccess = () => {
        let object = { isuser: false, message: formsuccess };

        setMessages(prevMessages => [...prevMessages, object]);

        if (videoRef.current) {
            setisvideoPlay(true);
            setisstaticVideo(false);
            videoRef.current.src = formvideo;
            videoRef.current.muted = !isSoundOn;
            videoRef.current.play();
            videoRef.current.loop = true;
            videoRef.current.onended = () => {
                setisvideoPlay(true);
                setisstaticVideo(true);
            };
        }
    };
    const languageselection = (value) => {
        setselectedlanguage(value)
    }
    const [hideshow, sethideshow] = useState(false)
    const hidetextformImage = () => {
        sethideshow(true)
    }
    return (
        <>

            <div className={preview ? "chartbotinsideopen videochartvalue " : "videochartvalue "}  >
                <div className={!showChatBot ? 'container' : "dnone"} id='ChatBotContainer'>
                    <div className='headAndOutput'>
                        <div className='chatHead'>
                            <div className='headIcontext'>
                                <div className='group-2'></div>
                                <div className='iconHeadChat'>
                                    <img src={avatarName == "Bharathi" ? bharathi : avatarName == 'natasha' ? "/img/chatAvatarIcon3.png" : avatarName == 'gala' ? chatBotAvatarGala : avatarName == 'diana' ? chatBotAvatarDiana : avatarName == 'aubrey' ? aubrey : avatarName == 'geuilia' ? geuilia : chatBotAvatarDiana} alt="Avatar" />
                                    <div className='headTextClass'>
                                        <div className="text-wrapper miniHead">Chat with</div>
                                        <div className="text-wrapper-2">AI Assistant</div>
                                    </div>
                                </div>
                            </div>
                            <div className='headMinClose'>
                                <div className='languagesDivBoth'>
                                    <div className=''   >
                                         <select className='languagesselect' onChange={(e)=> languageselection(e.target.value)} value={selectedlanguage}>
                                            {languages.map((lan, i)=>{
                                                return(
                                                    <option value={lan.code}>{lan.language}</option>
                                                )
                                            })}
                                            
                                             
                                         </select>
                                         
                                    </div>
                                </div>
                                <div className=' speakerIconButton' >
                                    <img src={isSoundOn ? chatSoundIconWhite : chatSpeakerMuteIcon} alt="Speaker" onClick={toggleSound} />
                                    <img src="/img/minimizeIcon/minimize1.png" alt="Line" onClick={() => { setShowChatBot(!showChatBot); }} style={preview ? {} : { opacity: 0 }} />
                                </div>
                            </div>
                        </div>
                        <div id="output-container">
                            <div className="messages-container">
                                {messages.map((item, index) => (
                                    <div key={index} className={`message-item ${item.isuser ? 'sender' : 'receiver'}`}>
                                        <div className='senderIconText'>

                                            <div className="message">
                                                {recordMessage && index === recentBotIndex ? (
                                                    <div className="chat-bubble-audio">
                                                        <div className="typing">
                                                            <div className="dot"></div>
                                                            <div className="dot"></div>
                                                            <div className="dot"></div>
                                                        </div>
                                                    </div>
                                                ) :
                                                    <>
                                                        <div className=''>
                                                            <TextRenderer text={item.message} domain={domain} />
                                                        </div>
                                                        {/* <p><a href={domain}>{}</a></p> */}

                                                        {item.form_status == false && item?.custom_payloads?.length !== 0 && item?.custom_payloads?.map((elem, index) => (
                                                            <div className='response-options'>
                                                                <button onClick={() => callApiOnPageLoad(elem.name)} type='button'>  {elem.name} </button>
                                                            </div>
                                                        ))}
                                                        {item.form_status ?
                                                            <>
                                                                <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
                                                                    <Paper
                                                                        elevation={3}
                                                                        sx={{
                                                                            p: 3,
                                                                            width: "100%",
                                                                            maxWidth: 400,
                                                                            border: "2px solid #90b832",
                                                                            borderRadius: "6px",
                                                                        }}
                                                                    >
                                                                        <Stack spacing={2}>
                                                                            {form_detailList.map((item, index) => (
                                                                                <div key={index}>
                                                                                    {/* <label htmlFor={`input-${index}`} style={{ fontWeight: "bold", display: "block", marginBottom: "4px" }}>
                                                                                        {item.label}
                                                                                    </label> */}
                                                                                    <input
                                                                                        id={`input-${index}`}
                                                                                        type="text"
                                                                                        name={item.label.toLowerCase()}
                                                                                        onChange={(e) => inputChangeTosubmit(e.target.value, formCount, item.form_details, index, item.label)}
                                                                                        placeholder={item.label}
                                                                                        style={{
                                                                                            width: "100%",
                                                                                            padding: "8px",
                                                                                            borderRadius: "6px",
                                                                                            // border: "1px solid #7ead18",
                                                                                            outline: "none",
                                                                                            fontSize: "16px",
                                                                                        }}
                                                                                    />
                                                                                    {item.validation && (
                                                                                        <span style={{ color: "red", fontSize: "12px", marginTop: "4px", display: "block" }}>
                                                                                            {item.validation}
                                                                                        </span>
                                                                                    )}
                                                                                </div>
                                                                            ))}

                                                                            {/* Send Button (Aligned Bottom-Right) */}
                                                                            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                                                                                <button
                                                                                    onClick={() => {
                                                                                        if (item.api_details) {
                                                                                            handleInputFormSubmit(event, item.api_details, formCount, item.form_details?.type || "Charfield", index);
                                                                                        } else {
                                                                                            console.error("api_details is missing for this item:", item);
                                                                                        }
                                                                                    }}
                                                                                >
                                                                                    <h3>Send</h3>
                                                                                </button>
                                                                            </Box>
                                                                        </Stack>
                                                                    </Paper>
                                                                </Box>


                                                            </>
                                                            : ""}
                                                    </>
                                                }


                                            </div>
                                            {item.isuser && <img src="/img/chatSenderIcon.png" alt="Sender Avatar" />}
                                            {item.isuser === false && <img src={avatarName == "Bharathi" ? bharathi : avatarName == 'natasha' ? "/img/chatAvatarIcon3.png" : avatarName == 'gala' ? chatBotAvatarGala : avatarName == 'diana' ? chatBotAvatarDiana : avatarName == 'aubrey' ? aubrey : avatarName == 'geuilia' ? geuilia : chatBotAvatarDiana} alt="Receiver Avatar" />}
                                        </div>
                                        <div ref={messagesEndRef} />
                                    </div>
                                ))}
                                {/* {messages.length == 0 && (
                                        <div className="chat-bubble-audio">
                                            <div className="typing">
                                                <div className="dot"></div>
                                                <div className="dot"></div>
                                                <div className="dot"></div>
                                            </div>
                                        </div>
                                    )} */}
                                {recordMessage && (
                                    <div className="chat-bubble-audio">
                                        <div className="typing">
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                        </div>
                                    </div>
                                )}
                                {typingLoading ? <div className="chat-bubble-audio">
                                    <div className="typing">
                                        <div className="dot"></div>
                                        <div className="dot"></div>
                                        <div className="dot"></div>
                                    </div>
                                </div> : ""}
                                <div ref={messagesEndRef} />
                            </div>
                            <div className="hello-container backgroundclass"
                                style={{backgroundImage:`url(https://d1duq3wrgv494c.cloudfront.net/static/${avatarName}/${avatarName}_static.jpg)`}}
                            >

                                <video className="staticVideoClass" width="100%" autoPlay ref={videoRef}  ></video>

                                {/* <img src={`https://d1duq3wrgv494c.cloudfront.net/static/${avatarName}/${avatarName}_static.mp4`} className={isstaticVideo ? "staticVideoClass" : "staticVideoClass dnone"} /> */}
                            </div>
                        </div>
                    </div>
                    {hideChatInput ?
                        <div className='outputHelpfulClass'>
                            <form onSubmit={handleFormSubmit} className="input-container">
                                <input
                                    type="text"
                                    value={inputValue}
                                    onChange={(e) => setInputValue(e.target.value)}
                                    placeholder="Enter your message"
                                    disabled={loading}
                                />
                                {isRecordingTemp ? (
                                    <div className="recording-indicator">
                                        <div onClick={sendAudioToApi} disabled={loading} className='iconButton'>
                                            <img src="/img/chatMicSpeakIcon.png" alt="Mic" />
                                        </div>
                                    </div>
                                ) : (
                                    <div className='iconButton' onClick={sendAudioToApi} disabled={loading}>
                                        <img src="/img/chatMicIcon.png" alt="Mic" />
                                    </div>
                                )}
                                <button type='submit' className='iconButton' disabled={loading} style={{ background: "none", padding: 0 }}>
                                    <img src="/img/chatSendIcon.png" alt="Send" />
                                </button>
                            </form>
                        </div> : ""}
                </div>
            </div >

            <div className={!showChatBot ? 'dnone' : " chatBoxImageClass"} >
            {!hideshow ?<div className='positionclassin'>
                     <h2>Hello! 🎉 Let’s get started. What’s on your mind?</h2>  
                    <div className='closeicon' onClick={()=> hidetextformImage()}> ❌</div>
                </div> : ""}
                  <div className='avatarimageHolder'>         
                <img src={`https://d1duq3wrgv494c.cloudfront.net/static/${avatarName}/${avatarName}_static.gif`} alt="" onClick={() => { setShowChatBot(!showChatBot); !onloadTime ? callApiOnPageLoad("hi", 'onloadtime') : ""; handleVideoPath() }} />
                </div>    
            </div>

        </>
    );
}

export default SreeChatID;